import { PageKey } from 'enums';
import { createContext, Dispatch, SetStateAction } from 'react';
import { Breadcrumb } from 'types';

export const initialBreadcrumbs = {
  userSheetBreadCrumbs: [
    {
      title: 'Portfolio',
      to: '/portfolio/zadat-badatelsky-dotaz',
      id: undefined,
      key: PageKey.PORTFOLIO_RESEARCH_SHEET_NEW,
    },
  ],
  breadcrumbs: [
    {
      title: 'Portfolio',
      to: '/portfolio/badatelske-listy',
      id: undefined,
      key: PageKey.PORTFOLIO_RESEARCH_SHEET,
    },
  ],
  setBreadcrumbs: () => {},
};

export const BreadcrumbsCtx = createContext<{
  breadcrumbs: Breadcrumb[];
  setBreadcrumbs: Dispatch<SetStateAction<Breadcrumb[]>>;
}>(initialBreadcrumbs);
